module.exports = __webpack_public_path__ + "static/FAVT_banner.e4c92e1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/templates/assets/FAVT_banner.png
// module id = 979
// module chunks = 101932004231744